import { Card, Dropdown, FloatButton, Tooltip } from 'antd'
import React from 'react'
import { useDispatch } from 'react-redux'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { useState } from 'react';
import AddNewAbonementClubServices from '../Modals/AddNewAbonementClubServices';
import EditNewAbonementClubServices from '../Modals/EditNewAbonementClubServices';
import SureModal from 'src/components/Modals/SureModal';
import { deleteClubService, getAbonementListClubServices, getServices } from 'src/store/Slices/AbonementsSlice';
import { openNotification } from 'src/components/helpers/notification'
import { useEffect } from 'react';

const MobileAbonementsServices = ({
    abonementListClubServices,
    abonementListClubServicesLoading,
    abonementCostInfo,
    abonementServiceInfo,
    setAbonementServiceInfo,
    mnemo
}) => {

    const dispatch = useDispatch()
    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsOpenClubEditServices(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Услуги')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '2',
            label: 'Удалить',
            onClick: () => { setIsOpenDeleteModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Услуги')?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenModalClubServ, setIsOpenModalClubServ] = useState(false)
    const [isOpenEditClubServices, setIsOpenClubEditServices] = useState(false)

    const onClickDelete = () => {
        dispatch(deleteClubService({ clubServiceId: abonementServiceInfo.id })).then(() => {
            openNotification({
                type: 'success',
                message: `Услуга успешно удалена`
            })
            dispatch(getAbonementListClubServices({
                AbonementClubId: abonementCostInfo.id
            }))
            setIsOpenDeleteModal(false)
        })
    }

    useEffect(() => {
        isOpenModalClubServ && dispatch(getServices())
    }, [isOpenModalClubServ])

    return (
        <>
            <AddNewAbonementClubServices
                visible={isOpenModalClubServ}
                setVisible={setIsOpenModalClubServ}
                abonementCostInfo={abonementCostInfo}
            />
            <EditNewAbonementClubServices
                visible={isOpenEditClubServices}
                setVisible={setIsOpenClubEditServices}
                abonementCostInfo={abonementCostInfo}
                abonementServicesInfo={abonementServiceInfo}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {abonementListClubServices?.data?.value?.rows.map(element => {
                return (
                    <Card
                        loading={abonementListClubServicesLoading}
                        title={`Услуга №: ${element.id}`}
                        extra={<Dropdown
                            menu={{
                                items,
                            }}
                        >
                            <a
                                onClick={() => { setAbonementServiceInfo(element) }}
                                className="text-primary text-decoration-none"
                            >
                                Действия <DownOutlined />
                            </a>
                        </Dropdown>}
                        style={{ width: 330, marginTop: 16 }}
                        key={element.id}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>№:</div>
                                <div>Наименование:</div>
                                <div>Услуга:</div>
                                <div>Цена:</div>
                                <div>Кол-во тренировок:</div>
                                <div>Изображение:</div>
                            </div>
                            <div>
                                <div>{element?.id ? element?.id : '-'}</div>
                                <div>{element?.serviceTitle ? <Tooltip title={element?.serviceTitle}>{element?.serviceTitle.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.serviceName ? <Tooltip title={element?.serviceName}>{element?.serviceName.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.price ? element?.price : '-'}</div>
                                <div>{element?.trainingsCount ? element?.trainingsCount : '-'}</div>
                                <div>{element?.imageUrl ? element?.imageUrl : '-'}</div>
                            </div>
                        </div>
                    </Card>
                )
            })}
            <FloatButton
                disabled={(!mnemo?.children?.find(el => el.name === 'Услуги')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                style={{ right: 24 }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setIsOpenModalClubServ(true)
                }}
            />
        </>
    )
}

export default MobileAbonementsServices